import React from 'react';
import './GenreBrowse.scss';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { Link } from '../../Devon/Components/InkyLink';
import { Genre } from '../../Models/Series';

const GenreBrowse = (props: { title: string, genres: { id: number, title: string }[]}): JSX.Element => {

    return (
        <div className='genre-browse-container'>
            <div className='genre-browse-book-header-wrapper'>
                {/*<h2 aria-label={'Browse by Genre'} className='genre-browse-book-header'>Browse by Genre</h2>*/}
                <h2 aria-label={props.title} className='genre-browse-book-header'>{props.title}</h2>
            </div>

            <div className='genre-browse-book-grid-wrapper'>
                {props.genres.map((item, idx) => (
                    <Link aria-label={`link to ${item.title?.toUpperCase()}`} to={`/browse?g=${item.id}`} className='genre-browse-book-link' key={item.title?.toUpperCase()}>{item.title?.toUpperCase()}</Link>
                ))}
            </div>

            <Link to={'/browse'} className='browse-all-link'>
                <KodanshaArrow text={'browse all'} invert/>
            </Link>
        </div>
    );
};

export default GenreBrowse;